<mat-card
	id="pilots-table"
	[hidden]="!pilots || pilots?.data?.length < 1"
	class="trip-table table-card total-table-border"
>
	<div #pilotsTable>
		<div fxLayout fxLayoutAlign="start center" class="mb-2 ml-2 mt-xs">
			<mat-form-field fxFlex="40%" class="mr-1">
				<input matInput type="text" [(ngModel)]="filterText" (keyup)="filterPilots()" placeholder="Filter" />
				<button
					*ngIf="filterText"
					mat-icon-button
					matSuffix
					(click)="filterText = ''; filterPilots()"
					[attr.aria-label]="'Clear'"
				>
					<mat-icon>close</mat-icon>
				</button>
			</mat-form-field>

			<h5 class="readonly-label">
				Status:
				<mat-select
					class="header-select"
					[(value)]="filterStatus"
					(selectionChange)="statusFilter(filterStatus)"
				>
					<mat-option
						class="header-item"
						*ngFor="let status of ['All', 'Not Started', 'Paid', 'Not Paid', 'Approved']"
						[value]="status"
					>
						{{ status }}
					</mat-option>
				</mat-select>
			</h5>
		</div>
		<mat-card-title>
			<mat-list class="trip-card-header">
				<mat-list-item>
					<h5 class="mt-0">Pilots</h5>
					<span fxFlex></span>
					<button
						mat-icon-button
						*ngIf="isExportToPayroll"
						(click)="exportToPayroll()"
						matTooltip="Export to payroll"
					>
						<i class="fa-1-5x fa fa-file-text-o"></i>
					</button>
					<button mat-icon-button (click)="copyEmails()" matTooltip="Copy Emails">
						<mat-icon>mail</mat-icon>
					</button>
					<button mat-icon-button (click)="exportToExcel()" matTooltip="Export to Excel">
						<i class="fa-1-5x fa fa-file-excel-o"></i>
					</button>
					<button mat-icon-button [matMenuTriggerFor]="menu" style="margin-right: -15px">
						<mat-icon>more_vert</mat-icon>
					</button>
					<mat-menu #menu="matMenu" class="menu-padding">
						<mat-checkbox
							class="optional-column"
							(change)="toggleColumn($event, 'email')"
							[checked]="false"
						>Email Address</mat-checkbox
						>
						<mat-checkbox
							class="optional-column"
							(change)="toggleColumn($event, 'flightHours')"
							[checked]="false"
							>Total Flight Hours</mat-checkbox
						>
						<mat-checkbox
							class="optional-column"
							(change)="toggleColumn($event, 'tripCount')"
							[checked]="false"
							>Trip Count</mat-checkbox
						>
						<mat-checkbox
							class="optional-column"
							(change)="toggleColumn($event, 'loadCount')"
							[checked]="false"
							>Load/Unload Count</mat-checkbox
						>
						<mat-checkbox
							class="optional-column"
							(change)="toggleColumn($event, 'hireDate')"
							[checked]="false"
							>Hire Date</mat-checkbox
						>
						<mat-checkbox
							class="optional-column"
							(change)="toggleColumn($event, 'payrollNumber')"
							[checked]="false"
						>Payroll Number</mat-checkbox
						>
						<mat-checkbox
							class="optional-column"
							(change)="toggleColumn($event, 'jobTitleName')"
							[checked]="false"
							>Job Title</mat-checkbox
						>
						<mat-checkbox
							class="optional-column"
							(change)="toggleColumn($event, 'aircraftModelName')"
							[checked]="false"
							>Aircraft Model</mat-checkbox
						>
						<mat-checkbox
							class="optional-column"
							(change)="toggleColumn($event, 'employmentStatus')"
							[checked]="false"
							>Employment Status</mat-checkbox
						>
					</mat-menu>
				</mat-list-item>
			</mat-list>
		</mat-card-title>
		<table
			mat-table
			[dataSource]="pilots"
			class="trip-table"
			matSort
			matSortActive="lastName"
			matSortDirection="asc"
		>
			<ng-container matColumnDef="checked">
				<th mat-header-cell *matHeaderCellDef>
					<mat-checkbox
						[checked]="selectAllPilots"
						[(ngModel)]="selectAllPilots"
						(change)="selectAll($event)"
					></mat-checkbox>
				</th>
				<td mat-cell *matCellDef="let element">
					<mat-checkbox [(ngModel)]="element.checked" (change)="onSelectPilotChange()"></mat-checkbox>
				</td>
			</ng-container>

			<ng-container matColumnDef="lastName">
				<th mat-header-cell *matHeaderCellDef mat-sort-header><strong>Pilot</strong></th>
				<td mat-cell *matCellDef="let element">
					<a
						class="timesheet-link"
						[routerLink]="['/pilotpay/time-sheets', element.employeeId]"
						[queryParams]="{ date: serializedDate }"
						>{{ element.firstName }} {{ element.lastName }}</a
					>
				</td>
			</ng-container>

			<ng-container matColumnDef="email">
				<th mat-header-cell *matHeaderCellDef mat-sort-header><strong>Email Address</strong></th>
				<td mat-cell *matCellDef="let element">{{ element.email }}</td>
			</ng-container>

			<ng-container matColumnDef="payrollNumber">
				<th mat-header-cell *matHeaderCellDef mat-sort-header><strong>Payroll Number</strong></th>
				<td mat-cell *matCellDef="let element">{{ element.payrollNumber }}</td>
			</ng-container>

			<ng-container matColumnDef="jobTitleName">
				<th mat-header-cell *matHeaderCellDef mat-sort-header><strong>Job Title</strong></th>
				<td mat-cell *matCellDef="let element">{{ element.jobTitleName }}</td>
			</ng-container>

			<ng-container matColumnDef="aircraftModelName">
				<th mat-header-cell *matHeaderCellDef mat-sort-header><strong>Aircraft Model</strong></th>
				<td mat-cell *matCellDef="let element">{{ element.aircraftModelName }}</td>
			</ng-container>

			<ng-container matColumnDef="hireDate">
				<th mat-header-cell *matHeaderCellDef mat-sort-header><strong>Hired</strong></th>
				<td mat-cell *matCellDef="let element">{{ element.hireDate | date: 'MM/dd/yyyy' }}</td>
			</ng-container>

			<ng-container matColumnDef="timeSheetStatus">
				<th mat-header-cell *matHeaderCellDef mat-sort-header><strong>Status</strong></th>
				<td mat-cell *matCellDef="let element">
					<span *ngIf="element.timeSheetStatus" [ngClass]="'submitTimeSheet' + element.timeSheetStatus">
						<span class="button-text">{{
							timeSheetStatusTextEnum[timeSheetStatusEnum[element.timeSheetStatus]]
						}}</span>
					</span>
					<span *ngIf="!element.timeSheetStatus" class="submitTimeSheet0">
						<span class="button-text">{{
							timeSheetStatusTextEnum[timeSheetStatusEnum[timeSheetStatusEnum.NotStarted]]
						}}</span>
					</span>
				</td>
			</ng-container>

			<ng-container matColumnDef="flightHours">
				<th mat-header-cell *matHeaderCellDef mat-sort-header><strong>Total Flight Hours</strong></th>
				<td mat-cell *matCellDef="let element">
					{{ element.flightHours || 0 }}h {{ element.flightMinutes || 0 }}m
				</td>
			</ng-container>

			<ng-container matColumnDef="tripCount">
				<th mat-header-cell *matHeaderCellDef mat-sort-header><strong>Trips</strong></th>
				<td mat-cell *matCellDef="let element">{{ element.tripCount || 0 }}</td>
			</ng-container>

			<ng-container matColumnDef="loadCount">
				<th mat-header-cell *matHeaderCellDef mat-sort-header><strong>Load/Unload</strong></th>
				<td mat-cell *matCellDef="let element">{{ element.loadCount || 0 }}</td>
			</ng-container>

			<ng-container matColumnDef="perDiemHours">
				<th mat-header-cell *matHeaderCellDef mat-sort-header><strong>Per Diem Hours</strong></th>
				<td mat-cell *matCellDef="let element">
					{{ element.perDiemHours || 0 }}h {{ element.perDiemHours || 0 }}m
				</td>
			</ng-container>

			<ng-container matColumnDef="guaranteedHours">
				<th mat-header-cell *matHeaderCellDef mat-sort-header>
					<strong>Guaranteed Hours Status</strong>
				</th>
				<td mat-cell *matCellDef="let element">
					<p *ngIf="element.flightHours || element.flightMinutes" class="font-weight-bold">
						{{ element.flightHours || 0 }}h {{ element.flightMinutes || 0 }}m / {{ element.guaranteedHours }}h
					</p>
				</td>
			</ng-container>

			<ng-container matColumnDef="totalPay">
				<th mat-header-cell *matHeaderCellDef mat-sort-header><strong>Total Pay</strong></th>
				<td mat-cell *matCellDef="let element" class="font-weight-bold">
					{{ element.totalPay | currency }}
				</td>
			</ng-container>

			<ng-container matColumnDef="employmentStatus">
				<th mat-header-cell *matHeaderCellDef mat-sort-header><strong>Employment Status</strong></th>
				<td mat-cell *matCellDef="let element">
					<i
						*ngIf="element.employmentStatus === employmentStatuses.Active"
						class="fa fa-circle color-green-deep icon-center"
						aria-hidden="true"
						matTooltip="Active"
						matTooltipPosition="right"
					></i>
					<i
						*ngIf="element.employmentStatus === employmentStatuses.LeaveOfAbsence"
						class="fa fa-circle color-orange-deep icon-center"
						aria-hidden="true"
						matTooltip="Leave Of Absence"
						matTooltipPosition="right"
					></i>
					<i
						*ngIf="element.employmentStatus === employmentStatuses.Terminated"
						class="fa fa-circle color-red icon-center"
						aria-hidden="true"
						matTooltip="Terminated"
						matTooltipPosition="right"
					></i>

					<i
						*ngIf="element.showInListsWasOverrode"
						class="fa fa-eye color-red icon-padding"
						aria-hidden="true"
						matTooltip="Pilot is shown because they have time on their time sheet."
						matTooltipPosition="right"
					></i>
				</td>
			</ng-container>

			<tr class="pilots-table-header" mat-header-row *matHeaderRowDef="displayedPilotsColumns"></tr>
			<tr mat-row *matRowDef="let row; columns: displayedPilotsColumns"></tr>
		</table>
	</div>
</mat-card>
